import cn from "classnames";
import { Button } from "components/UI/Buttons/Button";
import { IconImage } from "@/components/UI/IconImage";
import Image from "next/image";
import cs from "@/styles/modules/card.module.scss";
import s from "./FreeFeaturesCard.module.scss";
import { WrappedIcon } from "@/components/UI/WrappedIcon";

export type FreeFeaturesCardProps = {
  className?: string;
  title: string;
  features: {
    name: string;
    price: number;
  }[];
  total: number;
  button: {
    text: string;
    href: string;
  };
};

export const FreeFeaturesCard = ({ title, features, total, button, className }: FreeFeaturesCardProps) => {
  return (
    <div className={cn(cs.cardGlass, s.card, className)}>
      <div className={s.top}>
        <WrappedIcon icon="gift" className={s.img} />
        <div className={s.heading}>{title}</div>
        <ul className={s.features}>
          {features.map((feature) => (
            <li key={feature.name} className={s.feature}>
              <div className={s.featureLeft}>
                <IconImage size={20} icon="check" className={s.icon} />
                <span className={s.featureName}>{feature.name}</span>
              </div>

              <span className={s.featureRight}>
                <span className={s.featurePrice}>${feature.price}</span>
                <span className={s.featureFree}>
                  <Image src="/img/pages/homepage/free-text.svg" alt="" width={38} height={13} />
                </span>
              </span>
            </li>
          ))}
        </ul>
        <div className={s.total}>
          <span className={s.featureName}>Get all of these for:</span>
          <span className={s.featureRight}>
            <span className={s.featurePrice}>${total}</span>
            <span className={s.featureFree}>free</span>
          </span>
        </div>
      </div>
      <div className={s.bottom}>
        <div className={s.featureBtnWrap}>
          <Button href={button.href} icon="check-round" size="fullwidth" iconPosition="suffix">
            {button.text}
          </Button>
        </div>
      </div>
    </div>
  );
};
